import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState} from "react";
import Navbar from './pages/Navbar';
 import './App.css'
  import UserPage from './pages/UserPage'
 import Product from './pages/MatchingTool';
 import Intro2 from './pages/Home'
 import Matched from './pages/Matched';
 import ProductTable from './pages/Summary';

function App() {
  const [user_id, setUser_id] = useState(1);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Intro2 />} />
	 <Route path="/user" element={<UserPage user_id={user_id} setUser_id={setUser_id} />} /> 
	<Route path="/product_db" element={<Product user_id={user_id}/>}/>
	<Route path="/summary" element={<ProductTable/>}/>
	<Route path="/intro2" element={<Intro2/>}/>
	<Route path="/matched" element={<Matched/>}/>
      </Routes>
    </Router>
  );
//	  return <h1>App is alive</h1>;
}

export default App
